// 결제수단 노출 설정 섹션 URL (2026-08-06 KST 추가)
const paymentMethodSettingsSection = "/payment-method-settings";

export const paymentMethodSettingsPath = paymentMethodSettingsSection;
